module.exports = __webpack_public_path__ + "static/img/chengxinwangzhan.9d699b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/chengxinwangzhan.png
// module id = 1/Qc
// module chunks = 1